import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, MessageCircle } from 'lucide-react';
const faqs = [{
  question: 'What areas do you deliver to?',
  answer: 'We deliver throughout Tacoma, Puyallup, Federal Way, Auburn, Kent, Bonney Lake, and surrounding South King County areas.'
}, {
  question: 'What is the minimum order?',
  answer: 'Our minimum order is 5 cubic yards for all materials.'
}, {
  question: 'Do you offer same-day delivery?',
  answer: 'Yes! We offer same-day delivery for orders placed before 10 AM, subject to availability.'
}, {
  question: 'How do I know how much material I need?',
  answer: "Use our Material Calculator above, or give us a call and we'll help you estimate based on your project dimensions."
}, {
  question: 'What forms of payment do you accept?',
  answer: 'We accept cash, check, and all major credit cards. Payment is due upon delivery.'
}, {
  question: 'Can I pick up materials instead of delivery?',
  answer: 'We are a delivery-only service at this time. All materials are delivered directly to your location by our professional drivers.'
}, {
  question: 'Do you spread the gravel after delivery?',
  answer: 'It depends on the situation. In some cases we can spread the material depending on access, terrain, and the type of project. Give us a call to discuss your specific setup, and we will let you know what is possible.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 sm:py-24 bg-[#f3f0ec] dark:bg-[#292827] transition-colors duration-300 scroll-mt-32 border-t border-stone-400 dark:border-transparent" id="faq" data-id="element-362">
      {/* Header */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 mb-12 sm:mb-20 text-center" data-id="element-363">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} data-id="element-364">
          <h2 className="font-heading text-5xl sm:text-6xl md:text-7xl font-extrabold text-stone-900 dark:text-white tracking-tight mb-6" data-id="element-365">
            Da FAQs
          </h2>
          <p className="text-lg sm:text-xl text-stone-700 dark:text-stone-200 max-w-2xl mx-auto" data-id="element-366">
            Quick answers about delivery, materials & pricing. If your question
            isn't listed below, just give us a call.
          </p>
        </motion.div>
      </div>

      {/* FAQ List - Full Width */}
      <div className="w-full" data-id="element-367">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <motion.div key={index} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className={`w-full transition-colors duration-300 ${isOpen ? 'bg-[#2e8a44]' : 'bg-transparent'}`} data-id="element-368">
              <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-369">
                <button onClick={() => toggleFAQ(index)} className="w-full flex items-start justify-between gap-6 py-8 sm:py-12 text-left group" data-id="element-370">
                  <span className={`font-heading text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight transition-colors duration-300 ${isOpen ? 'text-white' : 'text-stone-900 dark:text-white group-hover:text-[#2e8a44] dark:group-hover:text-[#2e8a44]'}`} data-id="element-371">
                    {faq.question}
                  </span>
                  <motion.span animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className={`shrink-0 mt-1 sm:mt-2 transition-colors duration-300 ${isOpen ? 'text-white' : 'text-stone-900 dark:text-white'}`} data-id="element-372">
                    <Plus className="w-8 h-8 sm:w-12 sm:h-12 stroke-[1]" data-id="element-373" />
                  </motion.span>
                </button>

                <AnimatePresence data-id="element-374">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-375">
                      <p className="pb-12 sm:pb-16 text-lg sm:text-xl md:text-2xl text-white/95 leading-relaxed max-w-4xl font-medium" data-id="element-376">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </motion.div>;
      })}
      </div>

      {/* Still Have Questions */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 mt-8 sm:mt-10" data-id="element-377">
        <div className="flex flex-col sm:flex-row items-center justify-center text-center sm:text-left py-4 gap-3 sm:gap-5" data-id="element-378">
          <MessageCircle className="w-5 h-5 text-[#2e8a44] shrink-0" data-id="element-379" />
          <p className="text-stone-900 dark:text-white font-heading font-extrabold text-lg sm:text-xl" data-id="element-380">
            Still have questions?
            <span className="font-normal text-stone-600 dark:text-stone-400 text-base ml-2" data-id="element-381">
              Shoot us a text.
            </span>
          </p>
          <a href="sms:206-619-3742" className="inline-flex items-center justify-center px-6 py-2.5 bg-[#2e8a44] hover:bg-[#267038] text-white rounded-full font-bold text-sm transition-colors" data-id="element-382">
            Text Us
          </a>
        </div>
      </div>
    </section>;
}